<script lang="ts" setup>
import MenuBar from "@/components/MenuBar.vue";
import Notification from "@/components/Notification/index.vue";
import SidePanel from "@/components/SidePanel/index.vue";
import ModalWrapper from "@/components/Modal/index.vue";
</script>

<template>
  <MenuBar></MenuBar>
  <Notification></Notification>
  <RouterView></RouterView>
  <SidePanel></SidePanel>
  <ModalWrapper></ModalWrapper>
</template>

<style scoped></style>
